import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import ButtonPopup from '../components/button-popup';

interface ButtonPopupProcessorElement extends Element {
  props: Element['props'] & {
    buttonText: string;
    'data-erom-popup-button-text': string;
  };
}

const buttonPopup: Processor<ButtonPopupProcessorElement> = {
  priority: 10,
  name: 'buttonPopup',
  test: ({ node }) =>
    node.props?.hasOwnProperty('data-erom-popup-button-text') &&
    !!node.props?.className &&
    node.props.className.includes('wp-block-erom-button-popup'),
  processor: ({ node }) => {
    node.props.buttonText = node.props['data-erom-popup-button-text'];
    node.component = ButtonPopup as ComponentType;

    return node;
  }
};

export default buttonPopup;
